// extracted by mini-css-extract-plugin
export default {"container":"SettingsTab_container__VhTFy","container_paymentsBlock":"SettingsTab_container_paymentsBlock__NfAzw"};